//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { ArrowBackIcon } from "@chakra-ui/icons";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Collapse,
  Flex,
  FormControl,
  FormErrorMessage,
  HStack,
  Icon,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field, Formik } from "formik";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react-lite";
import React from "react";
import { HiOutlineRefresh } from "react-icons/hi";
import { object, string } from "yup";
import { EnhancedTextarea } from "../../components/form-elements/ExpandingTextArea";
import { getRandomElemFromArray } from "../../utils/functions";
import { DisplayCheckErrors } from "./DisplayCheckErrors";
import { SingleFormButton } from "./FormButtons";

const validationSchema = object().shape({
  title: string()
    .trim()
    .max(75, "Oops! Seems this headline is too long")
    .min(10, "Must be a minimum of 10 characters")
    .required("Give your subject a headline"),
});

const commonProps = ({ name }, { touched, errors }) => ({
  placeholder: "Type your subject headline",
  characterLimit: 75,
  isInvalid: Boolean(touched[name] && errors[name]),
  errorMessage: errors[name],
});

const SubjectTitleForm: React.FC<{
  value: { title: string };
  loading: boolean;
  subject: any;
  onSubmit: (params?: any) => Promise<any>;
  onBackClick: () => void;
  TUTORDATA: {
    education: Array<{
      school?: string;
      country?: string;
      specialty?: string;
      course?: string;
      grade?: string;
      degree?: string;
      startYear?: string;
      endYear?: string;
    }>;
    workHistory: Array<{
      company?: string;
      role?: string;
      isTeachingRole?: boolean;
      startYear?: string;
      endYear?: string;
      isCurrent?: boolean;
      showOnProfile?: boolean;
    }>;
  };
}> = observer(
  ({ value, loading, subject, onSubmit, TUTORDATA, onBackClick }) => {
    const [errorObj, setErrorObject] = React.useState<any>({});
    const [suggestions, setSuggestions] = React.useState<any>({});
    const { getSugestions, formatInput } = useTitleSuggestion(
      TUTORDATA,
      subject,
    );
    React.useEffect(() => {
      setSuggestions(getSugestions());
    }, []);

    const handleRefreshTitles = () => {
      setSuggestions(getSugestions());
    };

    const [showSuggestions, setShowSuggestions] = React.useState(false);

    const _handleSubmit = async (values, formikHelpers) => {
      formikHelpers.setSubmitting(true);
      try {
        let res = await onSubmit(values);
        formikHelpers.setSubmitting(false);
        return res;
      } catch (error) {
        formikHelpers.setSubmitting(false);
        if (error?.spellCheck) {
          formikHelpers.setErrors(error.spellCheck);
          if (error?.errors) {
            setErrorObject(error.errors);
          }
        }
      }
    };

    return (
      <Formik
        validationSchema={validationSchema}
        initialValues={value}
        onSubmit={_handleSubmit}
        render={({ handleSubmit }) => {
          return (
            <Box className="subject-headline">
              <Button
                mb={6}
                onClick={onBackClick}
                leftIcon={<ArrowBackIcon />}
                variant="link"
                colorScheme="blue"
              >
                Back
              </Button>

              <Stack pb={6}>
                <Text fontSize="3xl" fontWeight="bold" as="h1">
                  Add subject headline
                </Text>
                <Text mt={1} color="gray.700">
                  Write a catchy headline that summarizes your qualifications
                  and expertise in teaching {subject.name}. Be bold! Make a
                  strong headline. This is the first thing clients see.
                </Text>
              </Stack>
              <form>
                <Field
                  name="title"
                  render={({ field, form }) => {
                    return (
                      <Stack mb={8} spacing={6} pb={20}>
                        <FormControl
                          isInvalid={commonProps(field, form).isInvalid}
                        >
                          <EnhancedTextarea
                            padding="16px"
                            rounded="md"
                            resize="none"
                            fontSize="xl"
                            minHeight="132px"
                            borderColor="neutral.500"
                            fontWeight={field.value ? "medium" : "normal"}
                            _focus={{
                              borderColor: "blue.500",
                              boxShadow: "0 0 0 1px blue",
                            }}
                            {...field}
                            {...commonProps(field, form)}
                            characterCount={field.value.length}
                            onChange={(value) =>
                              form.setFieldValue(field.name, formatInput(value))
                            }
                          />
                          <FormErrorMessage>
                            {commonProps(field, form).errorMessage}
                          </FormErrorMessage>

                          {!isEmpty(errorObj) && (
                            <DisplayCheckErrors
                              name={field.name}
                              errors={errorObj}
                              subject={subject.name}
                            />
                          )}
                        </FormControl>

                        {suggestions?.displayed && (
                          <HStack justify="space-between" width="100%">
                            <Button
                              variant="link"
                              type="button"
                              colorScheme="blue"
                              onClick={() =>
                                setShowSuggestions(!showSuggestions)
                              }
                            >
                              See helpful examples?
                            </Button>

                            {showSuggestions && (
                              <Icon
                                cursor="pointer"
                                as={HiOutlineRefresh}
                                color="blue.500"
                                fontSize="xl"
                                onClick={handleRefreshTitles}
                              />
                            )}
                          </HStack>
                        )}

                        <Collapse in={showSuggestions}>
                          <TittleSuggestions
                            suggestions={suggestions?.displayed}
                            onChange={(value) => {
                              form.setFieldValue(field.name, value);
                            }}
                          />
                        </Collapse>
                      </Stack>
                    );
                  }}
                />

                <SingleFormButton
                  nextText="Save headline"
                  isLoading={loading}
                  onNextClick={handleSubmit}
                />
              </form>
            </Box>
          );
        }}
      />
    );
  },
);

export default SubjectTitleForm;

const Suggestion = ({ children, onClick, ...rest }) => {
  return (
    <Flex
      position="relative"
      borderWidth="2xs"
      role="group"
      onClick={onClick}
      overflow="hidden"
      cursor="pointer"
      borderColor="gray.300"
      rounded="md"
      px={4}
      pt={2}
      pb={5}
      {...rest}
    >
      {children}
      <Box
        _groupHover={{ bg: "blue.100" }}
        position="absolute"
        bg="gray.100"
        shadow="base"
        fontSize="xs"
        py="2px"
        px={2}
        bottom={0}
        fontWeight="medium"
        right={0}
      >
        {"Copy & edit"}
      </Box>
    </Flex>
  );
};

export const TittleSuggestions = ({ suggestions = [], onChange }) => {
  return (
    <Stack spacing={3}>
      <Alert mb={3} status="warning" variant="left-accent">
        <AlertTitle fontSize="sm" lineHeight="short">
          Don't copy these examples verbatim. Tweak them or create yours to
          stand out.
        </AlertTitle>
      </Alert>
      {suggestions.map((option, index) => (
        <Suggestion key={index} onClick={() => onChange(option)}>
          {option}
        </Suggestion>
      ))}
    </Stack>
  );
};

const TITLESUGGESTIONS = ({
  subject,
  educationLevel,
  education,
  experience,
}) => ({
  Academics: {
    ...(education.grade && {
      grade: [
        `${education.grade} in ${education.course} from ${education.school}. Expert ${subject.name} Tutor`,
        `${education.grade} ${educationLevel} of ${education.course}, I Help Learners Love ${subject.name}`,
        `Learn ${subject.name} from a Top-notch ${education.degree} ${education.grade} ${educationLevel}`,
        `Get Expert Help in ${subject.name} from an Outstanding ${education.grade} ${educationLevel}`,
        `${education.grade} ${subject.subcategory} Tutor with ${experience} Years Teaching ${subject.name}`,
      ],
    }),
    degree: [
      `${education.degree}. in ${education.course}, ${experience} Years Teaching ${subject.name}`,
      `${subject.name} Tutor with ${education.degree}. in ${education.course}, Love Helping Students Excel`,
      `Brilliant ${subject.name} Tutor, ${education.degree}. in ${education.course}`,
      `Experienced ${subject.subcategory} School Tutor Specializing in ${subject.name}`,
      `Hire The Best ${subject.name} Tutor in the World!`,
    ],
    results: [
      `100% Pass Rate in ${subject.name} Exams. Learn from the Best Tutor.`,
      `Certified ${subject.name}. ${education.degree} in ${education.course}`,
      `${education.degree} in ${education.course}, with ${experience}+ Years Tutoring Experience in ${subject.name}`,
      `An Excellent Teacher with an Innate Love for ${subject.name}`,
      `Get Better Grades in ${subject.name}. Book lessons now`,
    ],
  },
  "Test Prep": {
    ...(education.grade && {
      grade: [
        `${education.grade} in ${education.course} from ${education.school}. Expert ${subject.name} Tutor`,
        `${education.grade} ${educationLevel} of ${education.course}, I Help Learners Pass ${subject.name}`,
        `Study with a Top-notch ${subject.name} tutor. Get your desired score`,
        `Get Expert Help in ${subject.name} from an Outstanding ${education.grade} Tutor`,
        `${education.grade} ${subject.subcategory} Tutor with ${experience} Years Teaching ${subject.name}`,
      ],
    }),
    degree: [
      `${education.degree}. in ${education.course}, ${experience} Years Teaching ${subject.name}`,
      `${subject.name} Tutor with ${education.degree}. in ${education.course}, Love Helping Students Excel`,
      `Brilliant ${subject.name} Tutor, ${education.degree}. in ${education.course}`,
      `Experienced ${subject.subcategory} School Tutor Specializing in ${subject.name}`,
      `Hire The Best A* ${subject.name} Tutor in the World!`,
    ],
    results: [
      `100% Pass Rate in ${subject.name} Exams. Learn from the Best Tutor.`,
      `Certified ${subject.name} tutor. ${education.degree} in ${education.course}`,
      `${education.degree} in ${education.course}, with ${experience}+ Years Tutoring Experience in ${subject.name}`,
      `An Excellent ${subject.name} Tutor with Progress Succes in Exams`,
      `Get Better Grades in ${subject.name}. Book lessons now`,
    ],
  },
  Languages: {
    ...(education.grade && {
      grade: [
        `Book Lessons Now to learn ${subject.name} for Conversation, Academics or Business`,
        `Native ${subject.name} Tutor. Go from Beginner to Fluent Speaker`,
        `Learn to Speak ${subject.name} from an Experienced Tutor of ${experience} Years`,
        `Professional Language Tutor. I help Learners Read, Speak and Understand ${subject.name}`,
        `${experience} Years Experience Teaching ${subject.name} to Kids and Adults`,
      ],
    }),
    degree: [
      `Understand and Speak ${subject.name} Like a Native`,
      `I Make Learning ${subject.name} Fun and Easy. You'll Speak Fluently in No Time!`,
      `Brilliant ${subject.name} Tutor, ${education.degree}. in ${education.course}`,
      `Experienced ${education.grade} ${subject.name} Tutor`,
      `Hire The Best ${subject.name} Tutor in the World!`,
    ],
    results: [
      `We'll learn to Speak ${subject.name} through Practice, Songs and Play`,
      `Certified ${subject.name} Tutor. ${education.degree} in ${education.course}`,
      `${experience}+ Years Experience Teaching ${subject.name}`,
      `An Excellent ${subject.name} Teacher with an Innate Love for the Language`,
      `Get Better Grades in ${subject.name} Exams. Book lessons now`,
    ],
  },
  Music: {
    ...(education.grade && {
      grade: [
        `Book Lessons Now to Learn ${subject.name} Professionally`,
        `Expert ${subject.name} Tutor of ${experience} Years. Go from Beginner to Pro`,
        `Learn ${subject.name} from an Experienced Tutor of ${experience} Years`,
        `Fun ${subject.name} Lessons for Everyone! Learn From the Best`,
        `${experience} Years Experience Teaching ${subject.name} to Kids and Adults`,
      ],
    }),
    degree: [
      `Understand and Play ${subject.name} Like a Professional`,
      `I Make Learning ${subject.name} Fun and Easy. You'll Become a Pro in No Time!`,
      `Brilliant ${subject.name} Tutor, ${education.degree}. in ${education.course}`,
      `Experienced ${education.grade} ${subject.name} Tutor`,
      `Hire The Best ${subject.name} Tutor in the World!`,
    ],
    results: [
      `100% Pass Rate in ${subject.name} Exams. Learn from the Best Tutor.`,
      `Certified ${subject.name} Tutor. ${education.degree} in ${education.course}`,
      `${education.degree} in ${education.course}, with ${experience}+ Years Tutoring Experience in ${subject.name}`,
      `An Excellent Teacher with an Innate Love for ${subject.name}`,
      `Get Better Grades in ${subject.name} Exams. Book lessons now`,
    ],
  },
});

const getRecentEducation = (educationArray) => {
  let education = [...educationArray].sort((a, b) => b.endYear - a.endYear);
  let recentEducation = education[0];
  let educationLevel =
    recentEducation.endYear > new Date().getFullYear() ? "Student" : "Graduate";

  return { educationLevel, recentEducation };
};

const getYearsOfExperience = (workHistoryArray) => {
  let initialValue = 0;
  let teachingHistory = workHistoryArray.filter(({ isTeachingRole }) =>
    Boolean(isTeachingRole),
  );
  const reducer = (accumulator, currentValue) => {
    let experience = currentValue.isCurrent
      ? new Date().getFullYear() - currentValue.startYear
      : currentValue.endYear - currentValue.startYear;

    return accumulator + experience + 1;
  };
  return teachingHistory.reduce(reducer, initialValue);
};

const generateTutorDetails = (tutorData, subject) => {
  const { education, workHistory } = tutorData;
  const { educationLevel, recentEducation } = getRecentEducation(education);
  const unapplicableGrades = [
    "Not Applicable",
    "Other grade",
    "Lower Second Class",
  ];
  const grade = !unapplicableGrades.includes(recentEducation.grade)
    ? recentEducation.grade
    : null;
  const experience = getYearsOfExperience(workHistory);

  return {
    subject,
    educationLevel,
    education: { ...recentEducation, grade },
    experience,
  };
};

//SAMPLETUTORDATA to come from Context
export const useTitleSuggestion = (
  tutorData: { education: any[]; workHistory: any[] },
  subject: { name: string; category?: string; subcategory?: string },
) => {
  let tutorDetail = generateTutorDetails(tutorData, subject);
  function getSugestions() {
    let result: any[] = [];
    if (tutorDetail.subject.category) {
      let categoryData =
        TITLESUGGESTIONS(tutorDetail)[tutorDetail.subject.category] || {};
      let pp = Object.values(categoryData).map((groupArr: any) =>
        groupArr.filter(Boolean),
      );
      pp.forEach((group) => result.push(getRandomElemFromArray(group)));
      return { all: [...pp], displayed: result };
    }
    return { all: [], displayed: [] };
  }

  const removedPunctuations = ["!", "/", "&", "*"];

  const formatInput = (string) => {
    let formatedInput = string;
    let shouldContinue = true;
    while (shouldContinue) {
      let lastLetter = formatedInput.charAt(formatedInput.length - 1);
      if (removedPunctuations.includes(lastLetter)) {
        formatedInput = formatedInput
          .substring(0, formatedInput.length - 1)
          .trim();
      } else shouldContinue = false;
    }

    return formatedInput;
  };

  return { getSugestions, formatInput };
};
